export default {
  namespaced: true,
  state:{    
    documentTypes: [],    
    documentTypeCreate: {
      modal: false,
      values: {}
    },
    documentTypeEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    documentTypes(state){
      return state.documentTypes;
    },   
    documentTypeCreate(state) {
        return state.documentTypeCreate;
    },
    documentTypeEdit(state) {
      return state.documentTypeEdit;
    }    
  },
  mutations:{
    SET_DOCUMENT_TYPES(state, values){
      state.documentTypes = values;
    },
    SET_DOCUMENT_TYPE_CREATE_MODAL(state, value) {
      state.documentTypeCreate.modal = value;
    },
    SET_DOCUMENT_TYPE_CREATE_VALUES(state, value) {
      state.documentTypeCreate.values = value;
    },
    SET_DOCUMENT_TYPE_EDIT_MODAL(state, value) {
      state.documentTypeEdit.modal = value;
    },
    SET_DOCUMENT_TYPE_EDIT_VALUES(state, value) {
      state.documentTypeEdit.values = value;
    },
    PUSH_DOCUMENT_TYPE(state, value){
      state.documentTypes.push(value);
    },    
    SET_UPDATE_DOCUMENT_TYPE(state, values){
      var editedIndex = state.documentTypes.map(documentType => documentType.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.documentTypes[editedIndex], values);              
      }
      return;
    },
    SPLICE_DOCUMENT_TYPE(state, value){
      let i = state.documentTypes.map(documentType => documentType.id).indexOf(value);      
      state.documentTypes.splice(i, 1);
    }
  },
  actions:{
    getDocumentTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/document-types').then((response) => {
          commit('SET_DOCUMENT_TYPES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    documentTypeStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/document-types', formData).then((response) => {
          commit('PUSH_DOCUMENT_TYPE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    documentTypeUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/document-types/' + value, payload).then((response) => {          
          commit('SET_UPDATE_DOCUMENT_TYPE', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteDocumentType({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/document-types/' + value).then((response) => {
          commit('SPLICE_DOCUMENT_TYPE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
